module.exports = __webpack_public_path__ + "dist/img/logo-biblio.4e091137.png";